import { Moment } from 'moment';

export abstract class ItemActionBase {
    protected constructor(
        public readonly id: string,
        public readonly actionSeason: string,
        public readonly status: string,
        public readonly note: string,
        public readonly purchaseDate: string,
        public readonly startDate: string,
        public readonly arriveDate: string,
        public readonly endDate: string,
        public readonly saleChangeRatio: string/*number*/,
        public readonly saleIncrease: string/*number*/,
        public readonly replenishment: string,
        public readonly actionOut: string,
        public readonly importDate: string,
        public readonly documentNumber: string,
        public readonly cancelAction: string,
        public readonly purchaseType: string,
        public readonly prevActionAvgSale : string,
        public readonly prevActionPeriod : string,
        public readonly prevActionDocumentNumber : string,
        public readonly addAdditionalStock : number
        ) {
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/item-actions/item-action-base.ts